var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "86px",
    height: "71px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M -0.5,-0.5 C 28.1667,-0.5 56.8333,-0.5 85.5,-0.5C 85.5,23.1667 85.5,46.8333 85.5,70.5C 56.8333,70.5 28.1667,70.5 -0.5,70.5C -0.5,46.8333 -0.5,23.1667 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#da615e",
    d: "M 26.5,10.5 C 27.8333,10.5 29.1667,10.5 30.5,10.5C 30.1645,18.0853 28.8311,18.0853 26.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dc4a46",
    d: "M 18.5,12.5 C 21.4073,13.7341 23.7407,15.7341 25.5,18.5C 23.1637,19.0234 20.8303,18.5234 18.5,17C 17.2721,15.5098 17.2721,14.0098 18.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dd7b78",
    d: "M 18.5,23.5 C 19.9778,23.238 21.3112,23.5713 22.5,24.5C 20.5365,27.1939 19.2032,26.8606 18.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#da5f5e",
    d: "M 70.5,68.5 C 70.5,57.8333 70.5,47.1667 70.5,36.5C 65.8617,36.7054 61.5284,37.7054 57.5,39.5C 57.5,38.5 57.5,37.5 57.5,36.5C 56.325,36.719 55.325,36.3857 54.5,35.5C 56.297,34.3049 57.297,32.6382 57.5,30.5C 56.325,30.719 55.325,30.3857 54.5,29.5C 55.9501,28.1502 56.6168,26.4835 56.5,24.5C 51.4556,24.5822 46.4556,24.7488 41.5,25C 41.2362,20.2586 41.0695,15.4253 41,10.5C 39.9887,9.66337 38.8221,9.33003 37.5,9.5C 37.7662,13.6049 37.2662,17.6049 36,21.5C 33.9565,23.208 32.2899,25.208 31,27.5C 30.9466,34.1895 31.4466,40.8562 32.5,47.5C 35.5,47.5 38.5,47.5 41.5,47.5C 38.3586,48.3213 35.0252,48.8213 31.5,49C 32.7375,49.2321 33.7375,49.7321 34.5,50.5C 31.1149,50.8457 27.7816,51.5123 24.5,52.5C 22.9707,52.4712 21.804,51.8045 21,50.5C 19.5617,44.2154 18.895,37.882 19,31.5C 22.2025,30.6903 25.3692,29.6903 28.5,28.5C 30.4177,24.9961 32.5843,21.6628 35,18.5C 35.2069,14.9106 35.7069,11.4106 36.5,8C 39.3083,7.07992 41.4749,7.91326 43,10.5C 43.4155,14.848 43.2488,19.1813 42.5,23.5C 47.1398,22.6027 51.8065,22.4361 56.5,23C 58.1835,25.8677 59.1835,29.0344 59.5,32.5C 59.3201,33.5539 58.9867,34.5539 58.5,35.5C 62.7556,35.9361 67.089,35.9361 71.5,35.5C 71.8279,46.6794 71.4946,57.6794 70.5,68.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef8f8",
    d: "M 57.5,39.5 C 53.9206,39.7657 53.5873,41.099 56.5,43.5C 56.2907,44.086 55.9574,44.586 55.5,45C 50.8653,46.1018 46.1986,46.9351 41.5,47.5C 38.5,47.5 35.5,47.5 32.5,47.5C 31.4466,40.8562 30.9466,34.1895 31,27.5C 32.2899,25.208 33.9565,23.208 36,21.5C 37.2662,17.6049 37.7662,13.6049 37.5,9.5C 38.8221,9.33003 39.9887,9.66337 41,10.5C 41.0695,15.4253 41.2362,20.2586 41.5,25C 46.4556,24.7488 51.4556,24.5822 56.5,24.5C 56.6168,26.4835 55.9501,28.1502 54.5,29.5C 55.325,30.3857 56.325,30.719 57.5,30.5C 57.297,32.6382 56.297,34.3049 54.5,35.5C 55.325,36.3857 56.325,36.719 57.5,36.5C 57.5,37.5 57.5,38.5 57.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf6f6",
    d: "M 23.5,31.5 C 25.1667,31.5 26.8333,31.5 28.5,31.5C 29.4474,37.4657 30.1141,43.4657 30.5,49.5C 27.8938,50.1359 25.3938,50.1359 23,49.5C 21.8403,43.8707 21.0069,38.2041 20.5,32.5C 21.791,32.7373 22.791,32.404 23.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea2d2d",
    d: "M 70.5,68.5 C 61.1667,68.5 51.8333,68.5 42.5,68.5C 40.3861,62.2706 37.7194,56.2706 34.5,50.5C 33.7375,49.7321 32.7375,49.2321 31.5,49C 35.0252,48.8213 38.3586,48.3213 41.5,47.5C 46.1986,46.9351 50.8653,46.1018 55.5,45C 55.9574,44.586 56.2907,44.086 56.5,43.5C 53.5873,41.099 53.9206,39.7657 57.5,39.5C 61.5284,37.7054 65.8617,36.7054 70.5,36.5C 70.5,47.1667 70.5,57.8333 70.5,68.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopSales);
export default __webpack_public_path__ + "static/media/top_sales.7420d2bfdcea8eb2e0cdfcfa3171c75a.svg";
export { ForwardRef as ReactComponent };